const readyEvent = new Event('ytReady');
const playerWrapper = document.getElementById('ska-embed-player-wrapper');
const closeEmbedTriggers = document.querySelectorAll('.embedPlayer__close');
let ytplayer = null;

closeEmbedTriggers.forEach((trigger) => {
  trigger.addEventListener('click', () => {
    playerWrapper.dataset.active = 'false';
    ytplayer.stopVideo();
    document.getElementById('ska-embed-player').remove();

    const skaplayer = document.createElement('div');
    skaplayer.setAttribute('id', 'ska-embed-player');
    playerWrapper.querySelector('.embedPlayer__wrapper').prepend(skaplayer);
  });
});

function initYtPlayer() {
  // Create youtube script tag
  const tag = document.createElement('script');

  // Get src
  tag.src = 'https://www.youtube.com/iframe_api';

  // Place it in head
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function loadVideo(videoID: string) {
  // @ts-ignore Create a youtube player
  const player = new YT.Player('ska-embed-player', {
    height: '390',
    width: '640',
    videoId: videoID,
    playerVars: {
      playsinline: 1,
    },
    events: {
      onReady: () => {
        window.dispatchEvent(readyEvent);
        ytplayer = player;
      },
    },
  });

  // Return the player
  return player;
}

function openPlayer(event: Event) {
  // Stop redirect
  event.preventDefault();

  // load the video
  const player = loadVideo(this.id);

  // Set active on wrapper
  playerWrapper.dataset.active = 'true';

  // Play video once ready
  window.addEventListener('ytReady', () => {
    player.playVideo();
  });
}

// Get all links containing youtube id statements
const ytLinks = document.querySelectorAll('a[href*="youtube:"]');

// If found initialize the player links
if (ytLinks && ytLinks.length) {
  initYtPlayer();
  ytLinks.forEach((link: HTMLAnchorElement) => {
    // Get binding data
    const data = {
      id: link.getAttribute('href').match(/youtube:(.*)/)[1],
    };

    // Add event listener to open player
    link.addEventListener('click', openPlayer.bind(data));
  });
}
